import Page from "webPage/Page";
import Gallery from "webPage/Gallery";
import {handleScrollingSection} from "util/scrolling-section";
import $ from "jquery";

Page.register("page-template-technologies-inner-confluent", () => {

    let $roleSlider = $('.js-the-role-slider')

    if($roleSlider.length > 0) {
        sliderHandler($roleSlider);
    }

    $('body').on('click', '.js-accordion-btn', function () {
        if ($(window).outerWidth() < 760) {
            $(this)
                .closest('.accordion')
                .toggleClass('accordion--active')
                .find('.accordion__body')
                .stop()
                .slideToggle();
        }
    })

    handleScrollingSection($('.js-scrolling-logos'));
    handleScrollingSection($('.js-scrolling-logos-left'), "left");
});


function sliderHandler($el) {
    let slider = new Gallery($el, {
        itemClass: "info-slide__item",
        pipClass: "info-slide-btn",
        navigateClass: "js-navigate",
        pipsClass: "js-pips",
        itemsClass: "js-slide-wrap",
        itemActiveModifier: "active",
        pipActiveModifier: "active",
        animationDuration: 0,
        applyMinHeight: false,
    });

    let updatePipPosition = function (animate = true) {
        let $pip = slider.$pips.find("." + slider.settings.pipClass).eq(slider.getActiveIndex());
        let triangleWidth = $('.info-slide__triangle-wrap').outerWidth() / 2;

        let pipPos = $pip.position().left + ($pip.outerWidth() / 2) - triangleWidth;

        let $triangle = $el.find('.info-slide__triangle-wrap');

        if (!animate) {
            $triangle.addClass("info-slide__triangle-wrap--no-animate");
        }

        $triangle.css({
            "transform": "translateX(" + pipPos + "px)",
        });

        if (!animate) {
            // Force reflow
            $triangle.offset();
            $triangle.removeClass("info-slide__triangle-wrap--no-animate");
        }
    };

    slider.on('transitionEnd', function ({to}) {
        updatePipPosition();
    });

    updatePipPosition(false);
    $el.find('.info-slide__triangle-wrap').removeClass("info-slide__triangle-wrap--hidden");
    $(window).on('resize', function () {
        updatePipPosition(false);
    });
}

